import { PureComponent } from "react";

import DesktopContentComponent from "./desktop-content/desktop-content-component";
import MobileContentComponent from "./mobile-content/mobile-content-component";

import componentStyles from "./one-pager-with-image-content-component.scss";
import SocialProofComponent from "components/segments/social-proof/social-proof-component";
import ShortFooterComponent from "components/segments/short-footer/short-footer-component";
import VideosGalleryComponent from "components/segments/videos-gallery/videos-gallery-component";

export default class OnePagerWithImageContentComponent extends PureComponent {
  render() {
    const { videosGallery, SocialProof, ShortFooter } = this.props;
    const { showSocialProof, content: socialProofContent } = SocialProof;
    const { showShortFooter, content: shortFooterContent } = ShortFooter;

    return (
      <div className="one-pager-with-image-content-component">
        <div className="desktop-content-wrapper">
          <DesktopContentComponent {...this.props} />

          {showSocialProof && <SocialProofComponent {...socialProofContent} />}
          {showShortFooter && <ShortFooterComponent {...shortFooterContent} />}
          {videosGallery && <VideosGalleryComponent {...videosGallery} />}
        </div>

        <div className="mobile-content-wrapper">
          <MobileContentComponent {...this.props} />
        </div>

        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

OnePagerWithImageContentComponent.defaultProps = {
  textPart: {},
  imageWithBackgroundPart: {},
  collaborationWith: {},
  SocialProof: {},
  ShortFooter: {}
};
